import CaretDownFill from 'images/icon/CaretDownFill'
import CaretRightFill from 'images/icon/CaretRightFill'
import { Button, Col, Collapse, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { VehicleDataCard } from './VehicleDataCard'
import { GROUNDING_OVERVIEW_SECTION } from 'common/constants'
import { StyledCountingTextAndIcon, StyledGroudingLabelSection } from './GroundingSection.styled'
import { IGroundingOverviewData } from 'types/vehicleTypes'
import { getAwaitingReportUrl, getFilterSeachResultUrl } from 'utils/urlUtils'
import ViewReportIcon from 'images/icon/ViewReportIcon'
interface IProps {
  data: IGroundingOverviewData
  isExpand?: boolean
  setExpand?: any
}

export const GroundingSection = ({ data, isExpand, setExpand }: IProps) => {
  const HandleLink = (data) => {
    let viewReportURL
    if (data.sectionName === GROUNDING_OVERVIEW_SECTION.AWAITING_INSPECTION) {
      viewReportURL = getAwaitingReportUrl(
        data.minDateAwaitingInspection,
        data.maxDateAwaitingInspection,
        data.listOfVin
      )
    } else {
      viewReportURL = getFilterSeachResultUrl(data.filterField, data.filterValue)
    }
    window.location.href = viewReportURL
  }
  return (
    <>
      <div>
        <div>
          <span onClick={setExpand}>
            <StyledGroudingLabelSection>
              {isExpand ? <CaretDownFill /> : <CaretRightFill />}
              {data.sectionName.toUpperCase()}&nbsp;
              {data.sectionName !== GROUNDING_OVERVIEW_SECTION.AWAITING_INSPECTION && (
                <Button
                  variant="link"
                  as={'a'}
                  type={null}
                  onClick={(event) => {
                    HandleLink(data)
                    event.stopPropagation()
                  }}
                >
                  ({data?.vehicleDataList?.length ?? 0})
                </Button>
              )}
            </StyledGroudingLabelSection>
            {data.sectionName === GROUNDING_OVERVIEW_SECTION.AWAITING_INSPECTION && (
              <StyledCountingTextAndIcon>
                ({data?.vehicleDataList?.length ?? 0})&nbsp;
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-report">
                      <strong>View Report</strong>
                    </Tooltip>
                  }
                >
                  <ViewReportIcon
                    onClick={(event) => {
                      HandleLink(data)
                      event.stopPropagation()
                    }}
                  />
                </OverlayTrigger>
              </StyledCountingTextAndIcon>
            )}
          </span>
        </div>
        <Collapse in={isExpand}>
          <Row>
            {data.vehicleDataList?.map((item) => (
              <Col sm={12} lg={4} className="py-2" key={item.vehicle?.InstanceID}>
                <VehicleDataCard
                  isAwaitingInspection={data.sectionName === GROUNDING_OVERVIEW_SECTION.AWAITING_INSPECTION}
                  vehicleData={item}
                  key={item.vehicle?.InstanceID}
                />
              </Col>
            ))}
          </Row>
        </Collapse>
      </div>
    </>
  )
}
